import { useContext, Dispatch } from 'react';
import { AnalyticsAction, AnalyticsState } from '../types';
import { AnalyticsContext } from '../context';

export function useAnalyticsContext(): { state:AnalyticsState, dispatch: Dispatch<AnalyticsAction>} {
  const {state, dispatch} = useContext(AnalyticsContext);
  return {state, dispatch};
}
